/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Settings_DescInputs */

const en_simple_settings_desc = /** @type {(inputs: Simple_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plain language, no technical choices. Plans stay short and every step comes with an everyday explanation.`)
};

const id_simple_settings_desc = /** @type {(inputs: Simple_Settings_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa sehari-hari, tanpa pilihan teknis. Rencana jadi lebih ringkas dan setiap langkah punya penjelasan awam.`)
};

/**
* | output |
* | --- |
* | "Plain language, no technical choices. Plans stay short and every step comes with an everyday explanation." |
*
* @param {Simple_Settings_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_settings_desc = /** @type {((inputs?: Simple_Settings_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Settings_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_settings_desc(inputs)
	return en_simple_settings_desc(inputs)
});